export const ANALYTICS_ENABLED = import.meta.env.VITE_ANALYTICS_ENABLED === 'true';
export const ANALYTICS_DEBUGMODE =
  import.meta.env.VITE_ANALYTICS_DEBUGMODE === 'true';
export const ANALYTICS_TESTMODE = import.meta.env.VITE_ANALYTICS_TESTMODE === 'true';
export const ANALYTICS_TRACKINGID = import.meta.env.VITE_ANALYTICS_TRACKINGID;
